export const oneAppMessaging = [
  {
    name: 'Index',
    url: '/one-app/messaging/',
    icon: 'icon-home'
  },
  {
    name: 'Setting',
    url: '/one-app/messaging/setting',
    icon: 'icon-settings'
  },
  {
    name: 'History',
    url: '/one-app/messaging/history',
    icon: 'fa fa-history'
  }
];
